var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.type === 'menu')?_c('c-board-left-menu',{ref:"menu",attrs:{"item":_vm.item}}):_c('c-board-left-item',{attrs:{"item":_vm.item}})}
var staticRenderFns = []

export { render, staticRenderFns }